import { render, staticRenderFns } from "./OverviewMessageText.vue?vue&type=template&id=eb1a006a&scoped=true"
import script from "./OverviewMessageText.vue?vue&type=script&lang=js"
export * from "./OverviewMessageText.vue?vue&type=script&lang=js"
import style0 from "./OverviewMessageText.vue?vue&type=style&index=0&id=eb1a006a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1a006a",
  null
  
)

export default component.exports